import { render } from "./OverviewChart.vue?vue&type=template&id=02e45439&scoped=true"
import script from "./OverviewChart.vue?vue&type=script&lang=js"
export * from "./OverviewChart.vue?vue&type=script&lang=js"

import "./OverviewChart.vue?vue&type=style&index=0&id=02e45439&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e45439"]])

export default __exports__